module.exports = __webpack_public_path__ + "img/for_who_3_tablet.8eb3ae9.jpg";